import * as React from 'react';
import TriggersInput from 'src/components/inputs/Triggers';
import { Tab, Button, Icon } from 'semantic-ui-react';

// import validator from 'validator';
import { observer, inject } from 'mobx-react';
import TriggerableStat from 'src/stores/application/classes/TriggerableStat';
// import { removeTypename } from 'src/shared/typemap';
// import { ListInput } from '../../components/generic/ListInput';
// import { AnyLengthString } from 'aws-sdk/clients/comprehend';
import TabGrid from 'src/components/generic/GenericStoreTabs';

export class TriggerNotificationInput extends React.Component<any, any> {
    get currentStatValue() {
        return new TriggerableStat({
            ...this.state,
            clientId: this.props.value.clientId,
            typedId: this.props.value.typedId
        });
    }

    constructor(props: any) {
        super(props);
        
        if (props.isNew) {
            this.state = {
                ...props.value,
                associatedChart: props.chartId,
            };
        } else {
            this.state = {...props.value};
        }

        if (props.isFirst) {
            props.registerSaveCallback(this.saveCallback.bind(this));
        }
    }

    saveCallback() {
        const me = this;
        if (me.props.isFirst) {
            me.handleSaveCall();
            
        } 
    }

    render() {
        const {
            triggers
          } = this.state;
        const changeHandler = this.handleChange.bind(this);

        return (
            <Tab.Pane key={this.state.typedId}>
                <div>
                    {(JSON.stringify(this.props.value.triggers) === JSON.stringify(this.state.triggers)) ?
                        null : (
                            <Button.Group floated="right">
                                <Button type="button" key="save" onClick={this.handleSaveCall.bind(this)} positive>
                                    <Icon name="save"/> Save
                                </Button>,
                                <Button.Or  key="saveOr" />,
                                <Button  type="button" key="cancel" onClick={this.handleCancelCall.bind(this)} >
                                    <Icon name="cancel"/> Discard
                                </Button>,
                            </Button.Group>
                        )
                    }
                    <div  style={{clear: 'both'}}/> 
                </div>
                <TriggersInput 
                    name="triggers"
                    initialValue={triggers || []}
                    isStateBased={this.props.isStateBased}
                    possibleStates={this.props.possibleStates}
                    onChange={changeHandler}
                />
            </Tab.Pane>
        );
    }

    handleSaveCall() {
        const input = Object.assign(
            {},
            this.props.value,
            {
                triggers: this.state.triggers
            }
        );
        
        this.props.dataStore.update(input);
    }

    handleCancelCall() {
        this.setState(
            this.props.value
        );
    }

    handleChange(e: any, {name, value}: any) {
        this.setState({[name]: value});
    }
}

@inject('triggerableStats')
@observer
export default class TriggerableTabs extends React.Component<any, any> {
    validate() {
        return true;
    }

    render() {
        const props = this.props;
        const { triggerableStats } = this.props;
        
        let items = triggerableStats.getParsedItems;
        
        items = items.filter((p) => { 
            return p && p.associatedChart === props.chartId;
        });
        
        return (
            <div>
                <TabGrid 
                    dataStore={triggerableStats}
                    filter={(p) => { 
                        return p && p.associatedChart === props.chartId;
                    }}
                    sort={(a, b) => a.statIndex  - b.statIndex}
                    nameGen={(p) => `${p.name}`}
                    renderer={(p) => <TriggerNotificationInput {...p} {...props}/>}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/container/TriggerableStats/TriggerNotificationEdit.tsx